import Vue from "vue";
import Router from "vue-router";
import login from "@/pages/login/login.vue";
import index from "@/pages/index/index.vue";
import err404 from "@/pages/index/views/404.vue";

import brandWord from "@/pages/index/views/brandWord";
import indexQuery from "@/pages/index/views/indexQuery";
import accManage from "@/pages/index/views/accManage";
import companyManage from "@/pages/index/views/companyManage";

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);

export default new Router({
  // mode:'history',
  routes: [
    {
      path: "/",
      redirect: "/login",
    },
    {
      path: "*",
      redirect: "/404",
    },
    {
      path: "/login",
      name: "login",
      component: login,
      meta: {
        title: "登陆",
      },
    },
    {
      path: "/index",
      name: "index",
      component: index,
      redirect: "/brandWord",
      children: [
        {
          path: "/brandWord",
          name: "brandWord",
          icon: "el-icon-s-help",
          component: brandWord,
          meta: {
            title: "品牌关键词",
            activeName: ["brandWord"]
          },
        },
        {
          path: "/indexQuery",
          name: "indexQuery",
          icon: "el-icon-search",
          component: indexQuery,
          meta: {
            title: "指数查询",
            activeName: ["indexQuery"]
          },
        },
        {
          path: "/accManage",
          name: "accManage",
          icon: "el-icon-s-custom",
          component: accManage,
          meta: {
            title: "账号管理",
            activeName: ["accManage"]
          },
        },
        {
          path: "/companyManage",
          name: "companyManage",
          icon: "el-icon-s-promotion",
          component: companyManage,
          meta: {
            title: "企业管理",
            activeName: ["companyManage"]
          },
        },
      ],
    },
    {
      path: "/404",
      name: "404",
      component: err404,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js